import { render } from "./contentPage.vue?vue&type=template&id=d2de6b7e"
import script from "./contentPage.vue?vue&type=script&lang=js"
export * from "./contentPage.vue?vue&type=script&lang=js"

import "./contentPage.vue?vue&type=style&index=0&id=d2de6b7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__